import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { api } from '../utils/axios';
import { API_ENDPOINTS } from '../utils/config';
import { APP_CONSTANTS } from '../utils/constants';
export const useAuthStore = defineStore('auth', () => {
    const token = ref(localStorage.getItem('token'));
    const user = ref(null);
    const isAuthenticated = computed(() => !!token.value);
    const setToken = (newToken) => {
        token.value = newToken;
        localStorage.setItem('token', newToken);
    };
    const removeToken = () => {
        token.value = null;
        localStorage.removeItem('token');
    };
    const login = async (email, password) => {
        try {
            const response = await api.post(API_ENDPOINTS.login, {
                email,
                password,
                broker: APP_CONSTANTS.BROKER_ID
            });
            console.log('Login response:', response.data); // Debug log
            // Check for access_token in response
            if (response.data && response.data.access_token) {
                setToken(response.data.access_token);
                // Store user data if available
                if (response.data.user) {
                    user.value = response.data.user;
                }
                else {
                    // Create a user object from email if not provided
                    user.value = {
                        id: response.data.user_id || '',
                        email: email,
                        name: response.data.name || email.split('@')[0]
                    };
                }
                return true;
            }
            console.error('No access_token in response:', response.data);
            return false;
        }
        catch (error) {
            console.error('Login error:', error.response?.data || error.message || error);
            return false;
        }
    };
    const logout = () => {
        removeToken();
        user.value = null;
    };
    const checkAuth = async () => {
        if (!token.value) {
            console.log('No token found in checkAuth');
            return false;
        }
        try {
            console.log('Verifying token...');
            const response = await api.post(API_ENDPOINTS.verifyToken, {});
            console.log('Verify response:', response.data);
            // Consider the check successful if we get a 200 response
            // The token is already in the header, so a successful response means it's valid
            if (response.data) {
                // Update token if a new one is provided
                if (response.data.access_token) {
                    setToken(response.data.access_token);
                }
                // Update user data if provided
                if (response.data.user) {
                    user.value = response.data.user;
                }
                return true;
            }
            else {
                removeToken();
                return false;
            }
        }
        catch (error) {
            console.error('Auth check error:', error.response?.data || error.message || error);
            // Don't remove token on network errors, only on 401
            if (error.response?.status === 401) {
                removeToken();
            }
            return false;
        }
    };
    return {
        token: computed(() => token.value),
        user: computed(() => user.value),
        isAuthenticated,
        login,
        logout,
        checkAuth
    };
});
